module.exports = __webpack_public_path__ + "img/cont-01-tutela.8d8156d9.svg";